<!-- 时间控件完整代码 -->
<template>
  <!-- 日 周 月 季 年 时间选择控件 -->
  <div class="datetimepicker">
    <el-select
      v-model="selectt"
      @change="dateTypeSelectChange"
      :placeholder="$t('finance.select-apportion-dimension')"
      style="width: 160px"
      clearable
      @clear="dateTypeSelectClear"
    >
      <el-option :label="$t('v210831.year')" value="5"></el-option>
      <el-option :label="$t('base.quarter')" value="4"></el-option>
      <el-option :label="$t('base.month')" value="3"></el-option>
    </el-select>

    <el-date-picker
      v-if="selectt === '3'"
      v-model="listQuery.month"
      type="month"
      format="yyyyMM"
      value-format="yyyyMM"
      :picker-options="monthDateOption"
      :editable="false"
      @change="monthChange"
      :placeholder="$t('finance.select-month')"
    ></el-date-picker>

    <!-- <span > -->
    <jidu-date-picker v-if="selectt === '4'" ref="jidupicker" @chooseSeason="seasonChange"></jidu-date-picker>
    <!-- </span> -->

    <el-date-picker
      v-if="selectt === '5'"
      v-model="listQuery.year"
      type="year"
      format="yyyy"
      value-format="yyyy"
      :picker-options="yearDateOptions"
      :editable="false"
      @change="yearChange"
      :placeholder="$t('finance.select-year')"
    ></el-date-picker>
  </div>
</template>

<script>
import jiduDatePicker from "./jiduDatePicker.vue";
export default {
  name: "datetimepicker",
  data() {
    return {
      selectt: "",
      listQuery: {
        day: "",
        week: "",
        month: "",
        season: "",
        year: ""
      },

      monthDateOption: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now() - 8.64e7 * 30;
        // }
      },
      yearDateOptions: {
        // disabledDate: time => {
        //   return time.getTime() > Date.now() - 8.64e7 * 30 * 12;
        // }
      }
    };
  },
  components: {
    jiduDatePicker
  },
  props: {},
  methods: {
    dateTypeSelectChange(val) {
      // 选择时间类型下拉
      const data = {};
      if (val) {
        if (val === "3") {
          data.num = "3";
          data.time = this.getBeforeMonth();
        } else if (val === "4") {
          data.num = "4";
          data.time = this.getSeason();
          this.$nextTick(() => {
            this.$refs["jidupicker"].reset();
          });
        } else if (val === "5") {
          data.num = "5";
          data.time = this.getYear();
        }
        this.timereset();
        this.$emit("dateTypeSelectChange", data.time);
      }
    },
    dateTypeSelectClear() {
      // 通过 $data 获取组件的初始数据
      const initialData = this.$options.data.call(this);
      // 将初始数据赋值给 myObject 对象
      this.listQuery = initialData.listQuery;
      this.$emit("dateTypeSelectChange", "");
    },
    monthChange(val) {
      if (val) {
        const month = val;
        this.$emit("datetimeChange", month);
      } else {
        this.$emit("datetimeChange", this.getDate(new Date().getTime() - 24 * 3600 * 1000));
      }
    },
    seasonChange(val) {
      this.$emit("datetimeChange", val);
    },
    yearChange(val) {
      if (val) {
        const year = val;
        this.$emit("datetimeChange", year);
      } else {
        this.$emit("datetimeChange", this.getDate(new Date().getTime() - 24 * 3600 * 1000));
      }
    },
    timereset() {
      // 时间重置
      const date = new Date();
      this.listQuery.month = this.getBeforeMonth();
      this.listQuery.year = new Date(date.getTime());
    },
    reset() {
      this.selectt = "5";
      this.timereset();
    },
    getDate(time) {
      // 时间格式转化 年-月-日
      var date = new Date(time);
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getBeforeMonth() {
      // 获取上个月时间  年-月-日
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      var currentdate = year + month;
      return currentdate;
    },
    getSeason() {
      // 获取上一季度
      let year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      if (month <= 3) {
        return `${year}Q1`;
      } else if (month > 3 && month <= 6) {
        return `${year}Q2`;
      } else if (month > 6 && month <= 9) {
        return `${year}Q3`;
      } else if (month > 9 && month <= 12) {
        return `${year}Q4`;
      }
    },
    getYear() {
      // 获取上一年
      const year = new Date().getFullYear();
      return `${year}`;
    }
  },
  created() {},
  mounted() {
    this.timereset();
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.datetimepicker {
  display: inline-block;
}
</style>
<style lang="scss">
.datetimepicker {
  display: flex !important;
  flex-wrap: nowrap;
  .el-date-editor {
    flex: 1;
    margin-left: 20px;
  }
}
</style>
